<template>
  <div>
    <el-button type="primary" class="create" @click="clickCreate">{{buttonCaption}}</el-button>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    buttonCaption: {
      type: String,
      default: '作成'
    }
  },
  data () {
    return {}
  },
  methods: {
    clickCreate () {
      this.$emit('create')
    }
  }
}
</script>

<style lang="scss" scoped>
.create {
  width: 8em;
}
</style>
